import { useEffect,useState } from "react";
import { connect } from "react-redux";
import { withRouter, Link ,useHistory} from "react-router-dom";
import MultiStep from "react-multistep";
import { CssBaseline, Container, Paper, Box } from "@material-ui/core";
import StartupSteps from "./StartupSteps";
// import { getMentorForms } from "./dependencies/action";
import formbg from "../../assets/images/form-bg.jpg";
import applyIcon from "../../assets/images/close_icon.svg";
import "./styles.scss"
import { initGA,logPageView } from "../../analytics";

const StartupForms = (props) => {
  const [applicationStatus, setApplicationStatus] = useState("");
  
  useEffect(() => {
    // to call the initialise google analytics funtion
    try {
    initGA();
    window.GA_INITIALIZED = true;
    // to save the number og visitors on this side
    logPageView();
    } catch (error) {}
}, [window]);
  //
  // const steps = [
  // {name: 'StepOne', component: <Mentorstep1/>},
  // {name: 'StepTwo', component: <Mentorstep2/>},
  // {name: 'StepThree', component: <Mentorstep3/>},
  // ];

  // const { getMentorForms, mentorFormList } = props;
  // useEffect(() => {
  //   // getMentorForms();
  // }, [getMentorForms]);
  const history = useHistory();
  const gotoDashboard = () => {
    history.push("./startup-dashboard");
  };
  let value = localStorage.getItem("SavedLoggedInData");
    let LoginFormData = JSON.parse(value);
  useEffect(() => {
    let value = localStorage.getItem("SavedLoggedInData");
    let LoginFormData = JSON.parse(value);
    if (localStorage.getItem("loggedIn") === "true") {
      if (LoginFormData?.role == "Startup") {
        setApplicationStatus(LoginFormData?.applicationStatus);
      }
    }
    else{
      history.push("/login");
    }
  }, []);

  return (
    <div
      // style={{
      //   marginTop: "90px",
      //   paddingTop: "25px",
      //   // backgroundColor:"#000",
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   //  style={{
      //     backgroundImage:
      //       "linear-gradient(119deg, #D2D8ED 0%, #EFF9FD 53%, #ffffff 100%)",
      //   // }}
      //   // backgroundImage: `url(${formbg})`,
      // }}
      className="mainformdiv startupFormHeading"
    >

{ props.location.fromModule &&
        ( LoginFormData?.applicationStatus === "PENDING" || applicationStatus === "SUBMITTED" || applicationStatus === "DRAFT" ) &&
          
      <div className="" style={{marginRight:"85px",marginTop:"10px",height:"40px"}}>
        <div className="newUserTooltip">
          <div className="right-close2" onClick={()=>history.goBack()}>
        <img src={applyIcon} />{" "}
        <span className="tooltiptext tooltip-bottom">Close</span>
      </div>
      </div>
      </div>
     
}
        <p className="formHeadingStartupForm homepageSecondHeader" >
            {" "}
            MAARG Portal by Startup India{" "}
          </p>
      <h2 style={{ marginBottom: "-45px" }}>
        <p className="form-heading-style-bold formHeadingCohortFormPurple homepageFirstHeader" style={{ paddingTop:"15px"}}>Startup Application Form </p>
      </h2>
      {/* <Mentorstep1 />
            <Mentorstep2 />
            <Mentorstep3 /> */}
      {/* <MultiStep activeStep={0} showNavigation={true} steps={steps}/> */}
      <CssBaseline />
      <Container component={Box}>
        <Paper component={Box}>
          <StartupSteps 
          fromModule={props.location.fromModule}
          />
          {/* <StartupSteps
            formlist={mentorFormList}
            autoFetchedData={props.location.state}
          /> */}
        </Paper>
      </Container>
      <div className="formgraphicdiv"></div>
    </div>
  );
};


const mapStateToProps = (state) => {
  //
  //
  return {
    // mentorFormList: state.GetMentorFormReducer.getMentorFormList,
  };
};
export default connect(mapStateToProps)(
  withRouter(StartupForms)
);
